/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_translate_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which genetic code is used?`)
};

const es_translate_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué código genético se usa?`)
};

const de_translate_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcher genetische Code wird verwendet?`)
};

const nl_translate_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welke genetische code wordt gebruikt?`)
};

const fr_translate_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quel code génétique est utilisé ?`)
};

const it_translate_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quale codice genetico viene usato?`)
};

const pt_br2_translate_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual código genético é usado?`)
};

const pt_translate_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que código genético é usado?`)
};

const ja_translate_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どの遺伝暗号が使われますか？`)
};

const zh_translate_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用的是哪种遗传密码？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const translate_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.translate_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("translate_faq_q2", locale)
	if (locale === "en") return en_translate_faq_q2(inputs)
	if (locale === "es") return es_translate_faq_q2(inputs)
	if (locale === "de") return de_translate_faq_q2(inputs)
	if (locale === "nl") return nl_translate_faq_q2(inputs)
	if (locale === "fr") return fr_translate_faq_q2(inputs)
	if (locale === "it") return it_translate_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_translate_faq_q2(inputs)
	if (locale === "pt") return pt_translate_faq_q2(inputs)
	if (locale === "ja") return ja_translate_faq_q2(inputs)
	return zh_translate_faq_q2(inputs)
};